<bas-group-separator [name]="name"
                     [hint]="hint"
></bas-group-separator>
<ng-content></ng-content>